import ReceiptPreview from './preview.vue';
export default ReceiptPreview;
